var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 24.2085C3.39746 24.2085 4.125 24.936 4.125 25.8335V33.6113C4.125 34.2117 4.36352 34.7875 4.78808 35.2121C5.21264 35.6366 5.78847 35.8752 6.38889 35.8752H33.6111C34.2115 35.8752 34.7874 35.6366 35.2119 35.2121C35.6365 34.7875 35.875 34.2117 35.875 33.6113V25.8335C35.875 24.936 36.6025 24.2085 37.5 24.2085C38.3975 24.2085 39.125 24.936 39.125 25.8335V33.6113C39.125 35.0736 38.5441 36.4761 37.51 37.5102C36.476 38.5442 35.0735 39.1252 33.6111 39.1252H6.38889C4.92651 39.1252 3.52403 38.5442 2.48998 37.5102C1.45593 36.4761 0.875 35.0736 0.875 33.6113V25.8335C0.875 24.936 1.60254 24.2085 2.5 24.2085Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.851 1.35095C19.4856 0.71635 20.5145 0.71635 21.1491 1.35095L30.8713 11.0732C31.5059 11.7078 31.5059 12.7367 30.8713 13.3713C30.2367 14.0059 29.2078 14.0059 28.5732 13.3713L20.0001 4.7981L11.4269 13.3713C10.7923 14.0059 9.76339 14.0059 9.12878 13.3713C8.49418 12.7367 8.49418 11.7078 9.12878 11.0732L18.851 1.35095Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0.875C20.8975 0.875 21.625 1.60254 21.625 2.5V25.8333C21.625 26.7308 20.8975 27.4583 20 27.4583C19.1025 27.4583 18.375 26.7308 18.375 25.8333V2.5C18.375 1.60254 19.1025 0.875 20 0.875Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.98e5690723bcc4c44aa16aab8cc1de27.svg";
export { ForwardRef as ReactComponent };